module.exports = __webpack_public_path__ + "static/img/ZST.bb2fe53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/ZST.png
// module id = GOhW
// module chunks = 34